import React from 'react';

// components
import { DocumentHead } from 'components/DocumentHead';
import { Main } from './Main';
import { isCdkEnvironment } from '../../utils/constants';

export const PlaybackPage = () => {
  const title = isCdkEnvironment ? 'CDK Landing' : 'Covideo';
  return (
    <>
      <DocumentHead title={title} />
      <Main />
    </>
  );
};
